export default "__VITE_ASSET__CBL5ElWp__"